export const stateName = 'featureSwitches';